import React, { Component, useEffect, useRef } from 'react';
import FilterBy from './FilterBy';
import SearchBox from './SearchBox';

function AccessibleSearchBox() {
    const searchBoxRef = useRef(null);

    useEffect(() => {
        if (searchBoxRef.current) {
            const form = searchBoxRef.current.querySelector('.ais-SearchBox-form');
            const input = searchBoxRef.current.querySelector('.ais-SearchBox-input');
            const submitBtn = searchBoxRef.current.querySelector('.ais-SearchBox-submit');
            const resetBtn = searchBoxRef.current.querySelector('.ais-SearchBox-reset');

            if (form) {
                form.setAttribute('aria-label', 'Search Events');
            }
            if (input) {
                input.id = 'event-search-input';
            }
            if (submitBtn) {
                submitBtn.setAttribute('aria-label', 'Search');
            }
            if (resetBtn) {
                resetBtn.setAttribute('aria-label', 'Clear Search');
            }
        }
    }, []);

    return (
        <div ref={searchBoxRef}>
            <SearchBox 
                className="c-event-search-input" 
                translations={{ placeholder: 'Search Events' }} 
            />
        </div>
    );
}

class FilterToolbar extends Component {
    constructor(props) {
        super(props);
        this.state = { mobileMenuOpen: false };
        this.mobileFilterToggle = this.mobileFilterToggle.bind(this);
    }

    mobileFilterToggle(e) {
        e.preventDefault();
        this.setState({ mobileMenuOpen: !this.state.mobileMenuOpen });
    }

    render() {
        return (
            <div className="c-event-filters" style={{ zIndex: 5 }}>
                <div className="c-event-filter-set c-event-filter-set-search">
                    <label htmlFor="event-search-input" className="c-event-filter-set__description">
                        Search Events
                    </label>
                    <AccessibleSearchBox />
                </div>

                <button onClick={this.mobileFilterToggle} className="c-event-filters__mobile-toggle">
                    <i className="fas fa-filter" aria-hidden="true"></i>
                    Filter events
                </button>

                <div className={`c-event-filters__wrap faster ${this.state.mobileMenuOpen ? 'active fadeInDown' : ''}`}>
                    <div className="c-event-filter-set c-event-filter-set-dropdowns">
                        <div className="c-event-filter-set__description">
                            Filter by Date, Venue and Access
                        </div>
                        <FilterBy />
                    </div>
                </div>
            </div>
        );
    }
}

export default FilterToolbar;


// WEBPACK FOOTER //
// ./src/whatson/components/FilterToolbar.js